/* O canvas não resolve custom properties nem oklch() de forma confiável:
   lemos a cor já computada de sondas ocultas, uma por token. */

const NAMES = ['--line', '--line-faint', '--line-strong', '--signal', '--ink-4'] as const;
let probes: Record<string, HTMLElement> | null = null;

function ensure() {
  if (probes) return probes;
  const box = document.createElement('div');
  box.setAttribute('aria-hidden', 'true');
  box.style.cssText = 'position:absolute;width:0;height:0;overflow:hidden;pointer-events:none';
  probes = {};
  for (const n of NAMES) {
    const el = document.createElement('i');
    el.style.color = `var(${n})`;
    box.appendChild(el);
    probes[n] = el;
  }
  document.body.appendChild(box);
  return probes;
}

export interface Palette { line: string; faint: string; strong: string; brand: string; ink4: string }

export function readTokens(): Palette {
  const p = ensure();
  const c = (n: string) => getComputedStyle(p[n]!).color;
  return { line: c('--line'), faint: c('--line-faint'), strong: c('--line-strong'), brand: c('--signal'), ink4: c('--ink-4') };
}

export const calm = () => typeof matchMedia === 'function' && matchMedia('(prefers-reduced-motion: reduce)').matches;
export const dpr = () => Math.min(window.devicePixelRatio || 1, 2.5);
